// TODO: Change the name of this file to match your application
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Switch } from "react-router";
import { NavLink, Route, Redirect } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useFlag } from "@innovid/feature-flags-react";

import { Confirm
	, BladeInfo
	, ProgressIndicator
	, AppHeader
	, HighGround
	, Account
} from "rhombus-react";

import { FEATURE_FLAGS } from "featureFlag/featureFlag";

import { NavIcon } from "./socket/";
import Gravemind from "./Gravemind";
// import NotFound from 'widgets/NotFound';
import {
	loadUser,
	loadUserFrom,
	reloadUser,
	loadZendeskToken,
	loadSenators
} from "reducers/You";
import { AssetUploadController } from "context/AssetUploadContext";
import { CreativeUploadController } from "context/CreativeUploadContext";

import NAV_ITEMS from "widgets/header/NavItems";
import NotFound from "widgets/NotFound";
import SocialImportSocketError from "widgets/messages/SocialImportSocketError";
import VersionsImportSocketError from "widgets/messages/VersionsImportSocketError";
import YoutubeUrlImportSocketError from "widgets/messages/YoutubeUrlImportSocketError";
import DecisionSheetImportSocketError from "widgets/messages/DecisionSheetImportSocketError";
import ImportPreviewMessage from "widgets/messages/ImportPreviewMessage";
import PredictiveScoringNotification, { shouldRenderPredictiveScoring } from "./socket/formatters/PredictiveScoringFormatter";
import GlobalModals from "widgets/modals/GlobalModals";
import CoreAgentBlade from "widgets/modals/coreAgent/CoreAgentBlade";

import CreativeLibrariesScreen from "./routes/CreativeLibrariesScreen";
import CreativesList from "./routes/CreativesList";
import VersionList from "./routes/VersionList";

import QAPanel from "./routes/QAPanel";

import {
	API_URL,
	ENV,
	HOME_ROUTE,
	LOGIN_ASSETS_URL
} from "utils/constants";
import { getEnvironmentName } from "utils/common";
import { setKey } from "utils/Keyboard";
import Downloader from "utils/Downloader";
import { GlobalSocketGrowler } from "utils/SocketGrowlTriggers";
import { initPendo } from "utils/Pendo";
import theSenateLoaded from "utils/loadTheSenate";


import config from "utils/appConfig";

const BASE_TITLE = "Creative Manager - Innovid";

const CHANNEL_NAME = `hopi-${config?.buildENV}`;

const TWENTY_FOUR_HOURS_IN_MINUTES = 1440;

const innovidLogo = {
	url: null,
	image: `${LOGIN_ASSETS_URL}/bg/innovid-logo_light.svg`,
	alt: "Innovid Logo",
	title: "Innovid Logo",
};

function signoutUser(){
	window.location.href = `${API_URL}/logout`;
}


/**
 * [initZendesk description]
 * 		This inserts the Zendesk snippet into the DOM
 * 		It requires a `zendeskApiKey` to be configured in the Zendesk admin section
 *   	There are 2 (two) sections to adding this snippet
 *   		* The JWT authentication callback
 *   			Per Zendesk docs, this needs to be added before the Zendesk JS is loaded
 *   			For this reason we need to dynamically add the znippet to the document as opposed to including it in `index.html`
 *   		* Adding the script itself
 *
 *
 * 		To prevent application breaking things, we wrap both groups in a try/catch
 * 		This allows our Application to work regardless of the status of ZenDesk, the API key, or the JWT
 * 		*************************************************************
 * 		 We DO NOT WANT TO BREAK OUR APP if a 3rd party script fails
 *    	*************************************************************
 *
 * @param  {string}		The JWT configured for authentication to the Zendesk API
 * @return {undefined}
 */
function initZendesk(jwt = null){
	if(/dev/gi.test(config.buildENV)){
		console.info("%cZendesk%c is %cdisabled%c for local testing", "color: #a8b916; font-weight:bold;", "color:#fff; font-weight:normal;", "color:red; font-weight:bold;", "color:#fff; font-weight:normal;");
		console.log();
		return;
	}

	if(!config.zendeskApiKey){
		console.info("No API Key, Zendesk disabled");
		return;
	}

	try {
		window.zESettings = {
			webWidget: {
				authenticate: {
					/* eslint-disable object-shorthand */
					jwtFn:function(callback){
						callback(jwt);
					},
					/* eslint-enable object-shorthand */
				},
			},
		};
		console.log("Added Zendesk JWT to window");
	} catch (err){
		/* eslint-disable indent */
		console.groupCollapsed("Zendesk JWT Problem");
			console.error("Problem setting Zendesk Token");
			console.error(err);
		console.groupEnd();
		/* eslint-enable indent */
		return;
	}

	try {
		let script2 = document.createElement("script");
		script2.src = `https://static.zdassets.com/ekr/snippet.js?key=${config.zendeskApiKey}`;
		script2.id = "ze-snippet";
		document.head.appendChild(script2);
		console.log("Added Zendesk to document");
	} catch(err){
		/* eslint-disable indent */
		console.groupCollapsed("Zendesk Snippet Problem");
			console.error("Problem embedding the  Zendesk Snippet");
			console.error(err);
		console.groupEnd();
		/* eslint-enable indent */
	}
}	//end initZendesk()

// Gravemind.__debug = true;
let navItems = NAV_ITEMS;
navItems.push(NavIcon({
	domNode:"socket-messages-portal",
	debug:true,
	socketInstance:Gravemind,
}));

document.addEventListener("keydown", (e) => {
	/*
		When a form field has focus, we want to just blur it instead of closing modals.
		Rhombus uses react-aria-modal, which reads keydown events on `document` in order to
		close, so we want to intercept it and `stopImmediatePropagation` if the `activeElement`
		is a focusable input type.
	*/
	if(e.key !== "Escape"){ return; }
	const { activeElement } = document;
	const isInputActive = ["INPUT", "TEXTAREA", "SELECT"].includes(activeElement.tagName);
	if(isInputActive){
		e.stopImmediatePropagation();
		activeElement.blur();
	}
});

function AppHeaderWithFlag(props){
	const requireCurrentPassword = useFlag(FEATURE_FLAGS.REQUIRE_CURRENT_PASSWORD);
	return <AppHeader {...props} requireCurrentPassword={requireCurrentPassword} />;
}

export class Hopi extends React.Component {

	static defaultProps = {
		showConfirm:false,
		confirmProps:{},
		isBladeOpen:false,
		isReadOnly:false,
	};

	static propTypes = {
		showConfirm:PropTypes.bool.isRequired,
		isBladeOpen:PropTypes.bool.isRequired,
		isReadOnly:PropTypes.bool.isRequired,
	};

	// static getDerivedStateFromError(error) {
	// 	// Update state so the next render will show the fallback UI.
	// 	return { hasError: true };
	// }

	// state = { hasError:false };

	// componentDidCatch(error, info){
	// 	console.log("Oh man, something bad happened");
	// 	console.table(error);
	// 	console.info(info);
	// 	// return getDerivedStateFromError(error);
	// }

	constructor(props){
		super(props);

		this._renderConfirm = this._renderConfirm.bind(this);
		this._renderAppBody = this._renderAppBody.bind(this);
	}

	componentDidMount(){
		if(this.props.userId === -1) {
			this.props.loadUser(true)
				.then((resp) => {
					if(!resp?.success) { return; }

					Promise.all([this.props.loadSenators(), theSenateLoaded])
						.then(([sen]) => {
							if(!sen?.success) { return; }

							try {
								window.I_AM = new TheSenate(document.querySelector(".ft-header .ft-logo"), {
									appList:sen.payload.data.items,
								});
							} catch (err){
								console.error("He's too dangerous to keep alive!");
								console.error(err);
							}
						});	//end this.props.loadSenators.then()

					try {
						Promise.all([
							this.props.loadZendeskToken(),
							this.props.loadUserFrom()
						]).then(([zen, gateway]) => {
							if(zen.success && gateway.success){
								initZendesk(zen.payload.data?.jwt);
								initPendo(gateway.payload.data);
							}
						});
					} catch (err){
						console.error("Unable to load Pendo");
						console.error(err);
					}
					// Once the user has been loaded, connect to the user topic
					// This topic is *always* connected on app start up
					Gravemind.addTopics({
						name:`/topic/v1/user/${resp.payload.data.id}`,
						formatters:[
							{
								shouldRender({ origin, task, status }){
									if(/jcrm/i.test(origin) && /import social creatives/i.test(task) && /failed/i.test(status)){
										return true;
									}
									return false;
								},
								component:SocialImportSocketError,
							},
							{
								shouldRender({ origin, task, status }){
									if(/jcrm/i.test(origin) && /import youtube url creatives/i.test(task) && /failed/i.test(status)){
										return true;
									}
									return false;
								},
								component:YoutubeUrlImportSocketError,
							},
							{
								shouldRender({ origin, task, status }) {
									if(/jcrm/i.test(origin) && /import versions/i.test(task) && /failed/i.test(status)){
										return true;
									}
									return false;
								},
								component:VersionsImportSocketError,
							}, {
								shouldRender({ origin, task, status }) {
									if(/dtree/i.test(origin) && /version hedge upload/i.test(task) && /failed/i.test(status)){
										return true;
									}
									return false;
								},
								component:DecisionSheetImportSocketError,
							}, {
								shouldRender({ origin, task }){
									if(/jcrm/i.test(origin) && /^import versions with preview$/gi.test(task)){
										return true;
									}
									return false;
								},
								component:ImportPreviewMessage,
							}, {
								shouldRender: shouldRenderPredictiveScoring,
								component: PredictiveScoringNotification,
							}
						],
					});
					setKey("ctrl+shift+u", this.props.loadUserFrom);
				});
		}
	}

	_renderConfirm(){
		var { props } = this;

		if(!props.showConfirm){ return null; }

		return <Confirm.ConfirmModal {...props.confirmProps} onClose={props.onCloseConfirm} />;
	}

	_renderAppBody(){
		if(/expired/gi.test(this.props.session)){
			return null;
		}

		return (
			<CreativeUploadController>
				<AssetUploadController>
					<Switch>
						<Route exact path="/">
							<Redirect to={HOME_ROUTE} />
						</Route>
						<Route path="/libraries/" component={CreativeLibrariesScreen} />
						<Route
							path   = {`/library/:libraryId/creative/:creativeId/versions/`}
							render = {(routeRenderProps) => {
								let { libraryId, creativeId } = routeRenderProps.match.params;
								return (
									<VersionList
										libraryID = { libraryId }
										creativeId = { creativeId }
									/>
								);
							}}
						/>
						<Route
							path   = {`/library/:libraryId/`}
							render = {(routeRenderProps) => {
								let { libraryId } = routeRenderProps.match.params;
								return <CreativesList libraryId = { libraryId } />;
							}}
						/>
						<Route path="/qa-panel/" component={QAPanel} />
						<Route component={NotFound} />
					</Switch>
				</AssetUploadController>
			</CreativeUploadController>
		);
	}

	render(){
		var { props } = this
			, classes = classNames(["hopi-app"], { "is-blade-open": props.isBladeOpen, "is-read-only":props.isReadOnly })
			, isLoading = (!props.isUserLoaded && !props.isUserReloading) && !props.hasErrorLoading
			, title = BASE_TITLE
			, navItems = NAV_ITEMS
			, { currentPage, downloadURL, trackDownload, downloadName } = props
			, user = {
				id: props.userId,
				name: props.userName,
				firstName: props.userFirstName,
				lastName: props.userLastName,
				email: props.userEmail,
			}
			// , type = (props.userAccess === "write") ? "edit" : "view"
		;

		if (isLoading) {
			return <ProgressIndicator isLoading={isLoading} />;
		}

		if(props.hasErrorLoading){
			// Do something else if necessary?
		}

		if(props.session){
			try {
				window.I_AM.closeWidget();
			} catch (err){}
		}

		return (
			<section className={classes}>
				<ReactTooltip class="app-level-tooltip" effect="solid" backgroundColor="#374047" />
				<AppHeaderWithFlag
					environmentName={getEnvironmentName(ENV)}
					isAPIBusy={false}
					product={<NavLink to="/libraries/">creative manager</NavLink>}
					navItems={navItems}
					user={user}
					currentPage={currentPage}
					logo={innovidLogo}
					onSaveSettings={props.saveUserSettings}
					onSignout={signoutUser}
				/>
				<HighGround
					sessionLength={TWENTY_FOUR_HOURS_IN_MINUTES}
					onContinue={props.reloadUser}
					dispatch={props._dispatch}
					sessionType={props.session}
					channelName={CHANNEL_NAME}
				/>
				<Downloader url={downloadURL} onDownload={trackDownload} downloadName={downloadName} />
				<GlobalSocketGrowler />
				<GlobalModals />
				<CoreAgentBlade />
				{this._renderAppBody()}
				{this._renderConfirm()}
				<Helmet title={title} />
			</section>
		);
	}
}

function mapStateToProps(state, ownProps){
	return {
		showConfirm:  state.confirm.isOpen || false,
		confirmProps: state.confirm,
		isBladeOpen:  state.blade.isOpen,
		session:      state.session.type,
		// This should come from the user API, but until that is set up correctly, make it false
		isReadOnly:   false,

		// User Props
		userId: state.you.id,
		userName: state.you.userName,
		userFirstName: state.you.firstName,
		userLastName: state.you.lastName,
		userEmail: state.you.email,
		isUserLoaded:    state.you.isLoaded,
		isUserReloading: state.you.isReloading,
		userHasAccess:   state.you.hasAccess,
		hasErrorLoading: state.you.hasErrorLoading,

		currentPage: state.router?.location?.pathname,
		downloadURL:state.download.url,
		downloadName:state.download.name,
	};
}

function mapDispatchToProps(dispatch, ownProps){
	return {
		_dispatch:dispatch,
		onCloseConfirm(){ return dispatch(Confirm.closeConfirmAction()); },
		onToggleFullScreen(){ return dispatch(BladeInfo.onToggleFullScreen("edit")); },
		loadUser(suppressHighGround){ return dispatch(loadUser(suppressHighGround)); },
		loadUserFrom(){ return dispatch(loadUserFrom()); },
		trackDownload(){
			console.log("Tracking something");
		},
		loadZendeskToken(){ return dispatch(loadZendeskToken()); },
		reloadUser(){
			return dispatch(reloadUser());
		},
		saveUserSettings(values){
			return dispatch(Account.saveAccountInfo(values)).then((response) => {
				if(response?.success){
					return dispatch(reloadUser());
				}
			});
		},
		loadSenators(){
			return dispatch(loadSenators());
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Hopi);
